module.exports = __webpack_public_path__ + "img/app-or-code.fbc73131.png";